import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss'
import { connect } from 'react-redux';

import { setFormData as setStandardFormData } from '../../WarrantyStandardForm/redux/actions';
import { setFormData as setTransferFormData } from '../../WarrantyTransferForm/redux/actions';
import { setFormData as setClaimFormData } from '../../WarrantyClaimForm/redux/action';

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const CheckBox = ({ text, setStandardFormData, setTransferFormData, setClaimFormData, fieldKey, formData, children, noBorder }) => {
  const value = formData[fieldKey];

  function handleChange(event) {
    if (formData.formName == "WarrantyStandard") {
      setStandardFormData({ [fieldKey]: !formData[fieldKey] })
    } else if(formData.formName == "WarrantyClaim") {
      setClaimFormData({ [fieldKey]: !formData[fieldKey] })
    } else {
      setTransferFormData({ [fieldKey]: !formData[fieldKey] })
    }
  }

  return (
    <div className={noBorder ? styles.noBorderWrapper : styles.checkboxWrapper}>
      <label className={styles.checkbox}>
        <input
          type="checkbox"
          checked={value}
          onChange={() => handleChange()}
        />
        <span></span>
      </label>
      <p className={styles.checkboxText}>{text}</p>
      <p>{children}</p>
    </div>
  )
}

CheckBox.propTypes = {
  text: PropTypes.string,
};

const mapDispatchToProps = dispatch => (
  {
    setStandardFormData: (hash) => dispatch(setStandardFormData(hash)),
    setTransferFormData: (hash) => dispatch(setTransferFormData(hash)),
    setClaimFormData: (hash) => dispatch(setClaimFormData(hash))
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CheckBox);

